import { render, staticRenderFns } from "./SolutionPackages.vue?vue&type=template&id=4c32e90a&"
import script from "./SolutionPackages.vue?vue&type=script&lang=js&"
export * from "./SolutionPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports